import { Component } from '@builder.io/sdk';

const CTA_TYPE = {
  name: 'ctas',
  type: 'list',
  subFields: [
    {
      name: 'label',
      type: 'text',
      required: true,
    },
    {
      name: 'url',
      type: 'url',
      required: true,
    },
  ],
};

const whyBuyFromBeComponents: { tabName: string; path: string; components: Record<string, Component> } = {
  tabName: 'Why buy from BE',
  path: 'whyBuyFromBE',
  components: {
    PageHero: {
      name: 'Page Hero',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F9f2a69003c86470ea05deb9ecb9887be%2F20cccba4cb0a4ab49e27ec2569765cea',
      inputs: [
        {
          name: 'title',
          type: 'text',
          required: true,
        },
        {
          name: 'content',
          type: 'longText',
          required: true,
        },
        {
          name: 'videoUri',
          type: 'url',
          required: true,
        },
        {
          name: 'videoPoster',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
      ],
    },
    BeyondConflict: {
      name: 'Beyond Conflict',
      inputs: [
        {
          name: 'title',
          type: 'richText',
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
          required: true,
        },
        {
          name: 'ctas',
          type: 'list',
          subFields: [
            {
              name: 'label',
              type: 'text',
              required: true,
            },
            {
              name: 'url',
              type: 'url',
              required: true,
            },
          ],
        },
      ],
    },
    RecycledMetals: {
      name: 'Recycled Precious Metals',
      inputs: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'responsiveImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'title',
          type: 'text',
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
          required: true,
        },
        CTA_TYPE,
      ],
    },
    WhereWeSourceFrom: {
      name: 'WhereWeSourceFrom',
    },
    WBTitles: {
      name: 'Two tiles for Lab Created Diamonds and Recycled Diamonds',
      inputs: [
        {
          name: 'items',
          type: 'list',
          subFields: [
            {
              name: 'title',
              type: 'text',
              required: true,
            },
            {
              name: 'content',
              type: 'richText',
              required: true,
            },
            CTA_TYPE,
          ],
        },
      ],
    },
    WBPackaging: {
      name: 'Packaging',
      inputs: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'responsiveImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'title',
          type: 'text',
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
          required: true,
        },
      ],
    },
    CarbonFree: {
      name: 'Carbon Free Tile',
      inputs: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'alt',
          type: 'text',
          required: true,
        },
        {
          name: 'title',
          type: 'richText',
          required: true,
        },
        {
          name: 'logo',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
          required: true,
        },
        {
          name: 'cta',
          type: 'object',
          required: true,
          subFields: [
            {
              name: 'label',
              type: 'text',
              required: true,
            },
            {
              name: 'url',
              type: 'url',
              required: true,
            },
          ],
        },
      ],
    },
    ColoredGemstones: {
      name: 'Colored Gemstones',
      inputs: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'responsiveImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
        },
        {
          name: 'title',
          type: 'text',
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
          required: true,
        },
      ],
    },
    GemstoneOrigin: {
      name: 'Gemstone Origin',
    },
  },
};

export default whyBuyFromBeComponents;
